// extracted by mini-css-extract-plugin
export var container = "_fn-0";
export var content = "_fn-3";
export var customerTitle = "_fn-4";
export var empty = "_fn-5";
export var gray = "_fn-6";
export var header = "_fn-7";
export var info = "_fn-8";
export var loading = "_fn-2";
export var loadingCard = "_fn-9";
export var oneLine = "_fn-a";
export var personName = "_fn-e";
export var pillContainer = "_fn-b";
export var selected = "_fn-1";
export var text = "_fn-c";
export var twoLines = "_fn-d";
export var unread = "_fn-f";
export var unreadIndicator = "_fn-g";